import { useMemo } from "react";
import { Navigate, Outlet } from "react-router-dom"
import { TOKEN } from "../statics/localStorage";

export const AuthCheck = () => {
    const authToken = TOKEN();
    const token = useMemo(() => authToken, [authToken]);
    return token ? <Outlet /> : <Navigate to={"/login"} />;
}